import { TransformPlainObject } from 'worker/app-workers/shared/plainObjects/transform.plainObject';
import { TransformConvertorBase } from './adapterVisitor/convertors/transform.convertor';
import { UserDefinedFunctionLibrary } from 'app/model/dataflow/user-defined-function-library';
import { DataFlowParser } from './dataflow.parser';

export enum ParseScriptMethod {
    ALL,
    PARAMETERS,
    TRANSFORMATIONS
}
export class UserDefinedFunctionLibraryParser extends DataFlowParser {
    protected _getTransformationConvertor(transformationObject: TransformPlainObject, dataflow: UserDefinedFunctionLibrary): TransformConvertorBase {
        const transformName = transformationObject.modelName;
        const converter = super._getTransformationConvertor(transformationObject, dataflow);

        if (!converter) {
            switch (transformName) {
                // Add input and output here
                default:
                    return undefined;
            }
        } else {
            return converter;
        }
    }
}
